export default __webpack_public_path__ + "static/cosmo-5fab06e4ee036626200ef9dd02d435fc.jpg";